import { AppConfig } from "../config";
import { Agreement, normalizeAgreementKey } from "./Agreement";
import { AgreementMetadata } from "./AgreementMetadata";
import Bundle from "./Bundle";
import CreditCheckResult from "./CreditCheckResult";
import Product from "./Product";

/**
 * Payload for creating a SaleSys order.
 */
export default class OrderPayload {
  creditCheckResult: CreditCheckResult;
  bundles: Bundle[];
  agreement: Agreement;
  agreementMeta: AgreementMetadata;

  constructor(deriveFrom?: Partial<OrderPayload>) {
    if (!deriveFrom) {
      return;
    }

    Object.assign(this, deriveFrom);
  }

  /**
   * @returns Payload for SaleSys endpoint.
   */
  toJson(config: AppConfig, phoneNumber: string) {
    function reduceStockItems(items: Product[]) {
      let reducedItems: { [itemId: string]: { stockItemId: string; quantity: number; } } = {};

      for (let item of items) {
        if (reducedItems[item.id]) {
          reducedItems[item.id].quantity++;
        } else {
          reducedItems[item.id] = {
            stockItemId: item.id, quantity: 1
          }
        }
      }

      return Object.values(reducedItems);
    }

    const energyItems = [];

    let fields: { fieldId: string, value: string }[] = [
      {
        fieldId: config.orderFields.clientNameId,
        value: this.creditCheckResult.fullName
      },
      {
        fieldId: config.orderFields.clientSsnId,
        value: this.creditCheckResult.ssn
      },
      {
        fieldId: config.orderFields.clientAddressId,
        value: this.creditCheckResult.street
      },
      {
        fieldId: config.orderFields.clientCityId,
        value: this.creditCheckResult.city
      },
      {
        fieldId: config.orderFields.clientZipCodeId,
        value: this.creditCheckResult.zip,
      },
      {
        fieldId: config.orderFields.contactPhoneId,
        value: phoneNumber,
      },
      {
        fieldId: config.orderFields.agreementKeyId,
        value: normalizeAgreementKey(this.agreement.key)
      }
    ];

    if (this.creditCheckResult.credibility) {
      fields.push({
        fieldId: config.orderFields.clientCredibilityId,
        value: this.creditCheckResult.status
      });
    }

    for (const bundle of this.bundles) {
      energyItems.push(...reduceStockItems(bundle.energyItems));
    }

    return {
      fields,
      stockItems: [
        ...energyItems
      ],
      businessDate: this.agreementMeta?.signedAt,
      autoFill: true
    };
  }
}